<template>
  <v-app dark>
    <app-nav />
    <v-content>
      <transition-page>
        <router-view />
      </transition-page>
    </v-content>
  </v-app>
</template>

<script>
import AppNav from '@/components/nav/Nav.vue';
import TransitionPage from '@/components/TransitionPage.vue';

export default {
  name: 'App',
  components: { AppNav, TransitionPage },
};
</script>
